// @ts-nocheck
import logger from "@insite/client-framework/Logger";
import { get } from "@insite/client-framework/Services/ApiService";
import { PagesCollectionModel } from "@insite/client-framework/Services/ContentService";
import { PageModel } from "@insite/client-framework/Types/PageProps";
import { GetEventsApiParameter } from "@store/Framework/Store/Store/Pages/EventList/Handlers/GetEventList";

const eventsUrl = "/api/v1/events/getevents";

export async function getEvents(parameter: GetEventsApiParameter) {
    const result: PagesCollectionModel = { pages: [], pagination: {} as any };
    try {
        result.pages = await get<PageModel[]>(`${eventsUrl}`, parameter);
    } catch (error) {
        logger.warn(`Failed to load Event Page Collection: ${error}`);
    }

    if (!result.pages) {
        result.pages = [];
    }

    return result;
}
